<template>
  <standard-dialog
    v-model="model"
    :title="$t('pick_restaurant')"
    icon="mdi-silverware-fork-knife"
    :max-width="420"
  >
    <autocomplete
      v-model="pickedRestaurant"
      :items="allRestaurants"
      :label="$t('restaurant')"
      item-text="name"
      item-id="id"
      return-object
      :loading="loadingRestaurants"
    />

    <template v-slot:actions>
      <v-btn text @click="model = false">{{ $t("cancel") }}</v-btn>
      <primary-button :disabled="!pickedRestaurant" @click="confirm">
        {{ $t("continue") }}
      </primary-button>
    </template>
  </standard-dialog>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import restaurantService from "@/services/restaurant";

export default {
  name: "PickRestaurantDialog",
  components: { StandardDialog },
  mixins: [hasModel, hasSnackbar],
  data() {
    return {
      loadingRestaurants: false,
      pickedRestaurant: null,
      allRestaurants: [],
    };
  },
  watch: {
    model(open) {
      if (open) {
        this.pickedRestaurant = null;
        this.fetchRestaurants();
      }
    },
  },
  methods: {
    async fetchRestaurants() {
      if (this.allRestaurants.length) return;
      this.loadingRestaurants = true;
      try {
        const { data } = await restaurantService.getAllRestaurants();
        this.allRestaurants = data || [];
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_contracts"));
      } finally {
        this.loadingRestaurants = false;
      }
    },
    confirm() {
      if (!this.pickedRestaurant) return;
      this.model = false;
      this.$emit("confirm", this.pickedRestaurant);
    },
  },
};
</script>
